<template>
  <section
    id="menu"
    class=""
    :class="{ visible: this.$store.state.menu_is_visible }"
  >
    <div
      v-if="menu"
      v-for="(item, index) in menu"
      class="item"
      :class="{ selected: item.url === path, disabled: item.disabled }"
    >
      <router-link :to="item.url">
        <div class="icon-container">
          <img class="img" :src="item.img" @click.self="select(item)" />
          <span v-if="unreadMessages > 0 && item.url === '/orders'" class="notification-dot"></span>
        </div>
        <div class="content">
          <span class="name" @click.self="select(item)">{{ item.name }}</span>
          <span
            @click.self="select(item)"
            v-if="item.description"
            class="description"
            >{{ item.description }}</span
          >
          <span v-if="item.disabled" class="disabled">{{ $t('general.soon') }}</span>
        </div>
      </router-link>
      <Searcher string="" :refresh="true" v-if="item.search"></Searcher>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      /* menu: [
        {
          url: "/diagnostic",
          name: "Diagnóstico",
          description: "Conoce el área de influencia del restaurante",
          img: "/img/analyze.svg"
        },
        {
          url: "/marketing",
          name: "Plan de marketing local",
          description: "Define objetivos y estrategias",
          img: "/img/plan.svg"
        },
        {
          url: "/nacional",
          name: "Prioridades estratégicas",
          description: "Piezas de refuerzo y apoyo",
          selected: true,
          img: "/img/national.svg"
        },
        {
          url: "/local",
          name: "Oportunidades locales",
          description: "Piezas de activación",
          img: "/img/local.svg"
        },
        {
          url: "/toolkits",
          name: "Toolkits",
          description: "Herramientas y planes de acción",
          img: "/img/toolkits.svg"
        },
        {
          url: "/channels",
          name: "Medios",
          description:
            "Gestiona la informacion de tu restaurante (App, Web, RRSS...)",
          img: "/img/medios.svg"
        },
        {
          url: "/comunicacion",
          name: "Materiales de apoyo",
          description:
            "Recursos útiles para tu comunicación (Fotos, logos, manuales)",
          img: "/img/communication.svg"
        },
        {
          url: "/practices",
          name: "Best practices",
          description: "Conoce las mejores prácticas de los restaurantes",
          img: "/img/practices.svg"
        }
      ] */
    };
  },
  computed: {
    path() {
      return this.$route.path;
    },
    menu() {
      const menu = this.$store.getters["locations/getMenu"];
      const market = this.$store.getters["getMarket"];
      return menu[market];
    },
    unreadMessages() {
      const userType = this.$store.getters["user/getType"];
      console.log('unreadMessages', userType);
      if (userType) {
        this.$store.dispatch('orders/loadUnreadMessages', userType);
      }
      return this.$store.getters["orders/getUnreadMessages"];
    }
  },
  methods: {
    select(item) {
      if (!item.disabled) {
        this.$store.commit('locations/setMenuItemSelected', { 
          itemId: item.url, 
          selected: true 
        });
        this.$store.commit("setMenuVisible", false);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#menu {
  width: 100%;
  background: #fff;
  border-bottom: 2px solid #ffbb0c;
  padding: 10px 20px;
  position: relative;
  overflow: hidden;
  display: none;

  &.visible {
    display: block;
  }
  .item {
    width: 25%;
    padding: 10px;
    float: left;
    height: 80px;
    text-decoration: none;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);

      .img {
      }
    }
    &.selected {
      .content {
        .name {
          color: var(--main_color);
        }
      }
    }
    .icon-container {
      position: relative;
      float: left;
      
      .img {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin-top: 10px;
      }

      .notification-dot {
        position: absolute;
        top: 8px;
        right: -4px;
        width: 8px;
        height: 8px;
        background-color: red;
        border-radius: 50%;
        display: inline-block;
      }
    }
    .content {
      display: inline-block;
      width: calc(100% - 40px);
      padding: 6px 10px;
      text-align: left;

      .name {
        font-weight: bold;
        color: var(--dark_color);
        font-size: 13pt;
      }
      .description {
        display: block;
        font-size: 9.5pt;
        color: #777;
      }
      .disabled {
        display: block;
        font-size: 9.5pt;
        color: #777;
      }
    }
    .search {
      margin-top: -5px;
    }
  }
}
</style>
